import {
  DeleteOutlined,
  EyeOutlined,
  MoreOutlined,
  RetweetOutlined,
  SendOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, Image, Tag } from 'antd';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import {
  getStatusColor,
  getStatusLabel,
} from '../../../../utils/fn/mpProducts';
import { useMpProductsFilters } from '../../../../utils/zustand';

export const useMpProductColumns = ({
  hasActions = true,
  mappingDisabled: _mappingDisabled = false,
  onRemoveOneFromCategory = () => {},
  onPublishOne = () => {},
  onTransformOne = () => {},
} = {}) => {
  const { t } = useTranslation(['dashboard', 'common']);
  const navigate = useNavigate();
  const { filters } = useMpProductsFilters();

  const baseColumns = useMemo(
    () => [
      {
        title: 'Image principale',
        width: 50,
        key: 'image',
        render: (record) => {
          return (
            <Image
              src={record.product.main_image}
              fallback="data:image/png;base64,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"
              alt={record.reference}
            />
          );
        },
        fixed: 'left',
      },
      {
        title: 'Nom',
        dataIndex: 'name',
        key: 'name',
        width: 250,
        ellipsis: true,
        render: (name, record) => {
          return (
            <Link to={`/dashboard/mp-products/${record.id}`}>
              {record.product.name || 'Product name placeholder'}
            </Link>
          );
        },
      },
      {
        title: 'Référence',
        dataIndex: 'reference',
        key: 'reference',
        width: 150,
        render: (reference, record) => record.product.reference || '-',
      },
      {
        title: 'Statut',
        dataIndex: 'status',
        key: 'status',
        width: 120,
        render: (status) => (
          <Tag color={getStatusColor(status)}>{getStatusLabel(status)}</Tag>
        ),
      },
      {
        title: 'Catégorie Marketplace',
        dataIndex: ['mp_category', 'name'],
        key: 'mp_category',
        width: 200,
        render: (categoryName) =>
          categoryName ? <Tag color="blue">{categoryName}</Tag> : '-',
      },
      {
        title: 'Prix',
        dataIndex: 'price',
        key: 'price',
        width: 120,
        render: (price, record) =>
          price != null
            ? new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: record.currency || 'EUR',
              }).format(Number(price))
            : '-',
      },
      {
        title: 'Stock',
        dataIndex: 'quantity',
        key: 'quantity',
        width: 100,
        render: (quantity) => {
          if (quantity == null) return '-';
          const dotColor =
            quantity === 0 ? '#ff4d4f' : quantity > 50 ? '#52c41a' : '#fa8c16';
          return (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '2px 8px',
                borderRadius: 4,
                backgroundColor: '#f5f5f5',
              }}
            >
              <span
                style={{
                  display: 'inline-block',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: dotColor,
                  flexShrink: 0,
                }}
              />
              <span>{quantity}</span>
            </span>
          );
        },
      },
      {
        title: 'Store',
        dataIndex: ['store', 'name'],
        key: 'store',
        width: 200,
        render: (storeName, record) =>
          record.store?.name ? (
            <Tag color="blue">{record.store.name}</Tag>
          ) : (
            '-'
          ),
      },
      {
        title: 'Actions',
        key: 'actions',
        width: 80,
        fixed: 'right',
        render: (_, record) => {
          const menuItems = [
            {
              key: 'view',
              label: t('common:view'),
              icon: <EyeOutlined />,
              onClick: () => {
                navigate(`/dashboard/mp-products/${record.id}`);
              },
            },
            {
              key: 'map',
              label: t('common:map-product'),
              icon: <RetweetOutlined />,
              disabled: filters.has_mapping !== true,
              onClick: () => onTransformOne(record),
            },
            {
              key: 'broadcast',
              label: t('common:broadcast'),
              icon: <SendOutlined />,
              disabled:
                record.status !== 'mapped' && record.status !== 'integrated',
              onClick: () => onPublishOne(record),
            },
            {
              key: 'remove',
              label: t('common:remove-from-category'),
              icon: <DeleteOutlined />,
              danger: true,
              onClick: () => onRemoveOneFromCategory(record),
            },
          ];

          return (
            <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
              <Dropdown
                menu={{ items: menuItems }}
                trigger={['click']}
                placement="bottomRight"
              >
                <Button
                  type="default"
                  size="small"
                  icon={<MoreOutlined />}
                  onClick={(e) => e.stopPropagation()}
                />
              </Dropdown>
            </div>
          );
        },
      },
    ],
    [
      t,
      navigate,
      filters,
      onRemoveOneFromCategory,
      onPublishOne,
      onTransformOne,
    ]
  );

  // Mémoriser le résultat final pour éviter les recréations
  return useMemo(
    () =>
      hasActions
        ? baseColumns
        : baseColumns.filter((col) => col.key !== 'actions'),
    [hasActions, baseColumns]
  );
};
